import { Router, Route, Switch } from 'wouter-preact';
import { AppProviders } from './lib/contexts';
import { ErrorBoundary } from './components/ErrorBoundary';
import { LoginPage } from './pages/Login';
import { DashboardPage } from './pages/Dashboard';
import { SettingsPage } from './pages/Settings';

export function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <Router>
          <Switch>
            <Route path="/login" component={LoginPage} />
            <Route path="/" component={DashboardPage} />
            <Route path="/settings" component={SettingsPage} />
            <Route>
              <LoginPage />
            </Route>
          </Switch>
        </Router>
      </AppProviders>
    </ErrorBoundary>
  );
}
